import { render, staticRenderFns } from "./RegisterCoProducer.vue?vue&type=template&id=117a01a0&scoped=true&"
import script from "./RegisterCoProducer.vue?vue&type=script&lang=js&"
export * from "./RegisterCoProducer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoProducer.vue?vue&type=style&index=0&id=117a01a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a01a0",
  null
  
)

export default component.exports